export default __webpack_public_path__ + "static/media/cc_brown.d63c17b2.jpg";